import mutations, { initialDeviceState } from "./mutations";
import getters from "./getters";
import actions from "./actions";

export default {
    namespaced: true,
    state(){
        return initialDeviceState();
    },
    mutations,
    getters,
    actions
}